<template>
  <div>
    <el-submenu v-if="item.children && item.children.length" :index="resolvePath(item.path)">
      <template slot="title">
        <i :class="item.meta.icon"></i>
        <span>{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(item.path)"
      />
    </el-submenu>
    <el-menu-item v-else :index="resolvePath(item.path)">
      <i :class="item.meta.icon"></i>
      <span slot="title">{{ item.meta.title }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: Object,
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    resolvePath(routePath) {
      if (routePath.startsWith('/')) return routePath;
      // 拼接 basePath 和当前 path
      return this.basePath + '/' + routePath;
    }
  }
};
</script>